import { render, staticRenderFns } from "./DomainsCrud.vue?vue&type=template&id=9bdaaf54&scoped=true"
import script from "./DomainsCrud.vue?vue&type=script&lang=js"
export * from "./DomainsCrud.vue?vue&type=script&lang=js"
import style0 from "./DomainsCrud.vue?vue&type=style&index=0&id=9bdaaf54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bdaaf54",
  null
  
)

export default component.exports